// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useContext } from 'react';
import { RouteProps, useHistory, useLocation, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl';
import { COGNITO_USER_POOL_WEB_CLIENT_ID } from '../../configuration'
import { getAuthToken } from '../../apis/member';

import MemberContext from '../../contexts/MemberContext';
import CommonContext from '../../contexts/CommonContext';

import S from './styles';
import LogoIcon from '../../assets/images/logo.svg';
import ErrorPage from '../ErrorPage';

interface RouteParams {
  id: string;
}

const RedirectBifrost = (props: RouteProps): JSX.Element => {
  const { id } = useParams<RouteParams>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const source = queryParams.get('source');
  const member = useContext(MemberContext);
  const common = useContext(CommonContext);
  const history = useHistory();
  const [errors, setErrors] = useState<boolean>(false);
  const intl = useIntl();

  // Comment in case we need to use it again in the future
  // const checkCognitoStatus = () => {
  //   let cognitoExist = false;
  //   const cognitoKey = localStorage.getItem('CognitoKey');
  //   if (cognitoKey) {
  //     const idToken = localStorage.getItem(`${cognitoKey}.idToken`)
  //     if (!idToken) {
  //       member.clear();
  //       localStorage.removeItem('CognitoKey');
  //     } else {
  //       const parseJwt = (token:string) => { return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()); }
  //       const exp = new Date(new Date(0).setUTCSeconds(parseJwt(idToken).exp));
  //       const now = new Date();
  //       if (exp.valueOf() > now.valueOf()) {
  //         cognitoExist = true;
  //       } else {
  //         cognitoExist = false;
  //       }
  //     }
  //   }
  //   return cognitoExist;
  // }

  useEffect(() => {
    if (source !== 'bifrost') {
      setErrors(true);
    } else if (id) {
      const checkAuth = async (id: string) => {
        await getAuthToken(id).then(async (result:any) => {
          member.removeCognito();
          let body = result.data;
          try {
            body = JSON.parse(result.data)
          } catch (e) {
            body = result.data
          }
          const userName = body.AuthenticationResult.UserName;
          const cognitoKey = `CognitoIdentityServiceProvider.${COGNITO_USER_POOL_WEB_CLIENT_ID}.${userName}`
          localStorage.setItem('CognitoKey', cognitoKey);
          localStorage.setItem(`${cognitoKey}.accessToken`, body.AuthenticationResult.AccessToken);
          localStorage.setItem(`${cognitoKey}.refreshToken`, body.AuthenticationResult.RefreshToken);
          localStorage.setItem(`${cognitoKey}.idToken`, body.AuthenticationResult.IdToken);
          localStorage.setItem(`CognitoIdentityServiceProvider.${COGNITO_USER_POOL_WEB_CLIENT_ID}.LastAuthUser`, userName);
          member.setIsBifrostLogin(true);
          await member.update();
          await common.update();
          history.push('/home');
        }).catch((error: any) => {
          console.log(error)
          member.removeCognito();
          setErrors(true);
        })
      }
      checkAuth(id);
    } else {
      // redirect to login page
      history.push('/login');
    }
  }, []);

  if (errors) {
    return (
      <>
        <S.ErrorBody>
          <S.Container>
            <S.Header>
              <S.HeaderLogo src={LogoIcon} alt="Logo" />
            </S.Header>
            <S.LoadingContainer>
              <ErrorPage errorType={'Bitfrost'}/>
            </S.LoadingContainer>
            <S.Footer/>
          </S.Container>
        </S.ErrorBody>
      </>
    )
  }

  return (
    <>
      <S.PopMask>
      </S.PopMask>
      <S.ErrorBody>
        <S.Container>
          <S.Header>
            <S.HeaderLogo src={LogoIcon} alt="Logo" />
          </S.Header>
          <S.LoadingWrapper>
            <S.LoadingAnimation />
            <S.LoadingText>{intl.formatMessage({ id: 'J066' })} </S.LoadingText>
          </S.LoadingWrapper>
          <S.Footer/>
        </S.Container>
      </S.ErrorBody>
    </>
  )
}

export { RedirectBifrost as default }
